module.exports = __webpack_public_path__ + "public/images/program/program-19.4ece026170babf6decd8c125a201d5e7.jpg";